/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsMachineLicensePricingInfo
 */
export interface ControlcenterMelcoModelsMachineLicensePricingInfo {
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsMachineLicensePricingInfo
     */
    current_licenses_count?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsMachineLicensePricingInfo
     */
    current_licenses_cost?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsMachineLicensePricingInfo
     */
    current_total_cost?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsMachineLicensePricingInfo
     */
    new_licenses_count?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsMachineLicensePricingInfo
     */
    new_licenses_cost?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsMachineLicensePricingInfo
     */
    new_total_cost?: number;
}

export function ControlcenterMelcoModelsMachineLicensePricingInfoFromJSON(json: any): ControlcenterMelcoModelsMachineLicensePricingInfo {
    return ControlcenterMelcoModelsMachineLicensePricingInfoFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsMachineLicensePricingInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsMachineLicensePricingInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'current_licenses_count': !exists(json, 'current_licenses_count') ? undefined : json['current_licenses_count'],
        'current_licenses_cost': !exists(json, 'current_licenses_cost') ? undefined : json['current_licenses_cost'],
        'current_total_cost': !exists(json, 'current_total_cost') ? undefined : json['current_total_cost'],
        'new_licenses_count': !exists(json, 'new_licenses_count') ? undefined : json['new_licenses_count'],
        'new_licenses_cost': !exists(json, 'new_licenses_cost') ? undefined : json['new_licenses_cost'],
        'new_total_cost': !exists(json, 'new_total_cost') ? undefined : json['new_total_cost'],
    };
}

export function ControlcenterMelcoModelsMachineLicensePricingInfoToJSON(value?: ControlcenterMelcoModelsMachineLicensePricingInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'current_licenses_count': value.current_licenses_count,
        'current_licenses_cost': value.current_licenses_cost,
        'current_total_cost': value.current_total_cost,
        'new_licenses_count': value.new_licenses_count,
        'new_licenses_cost': value.new_licenses_cost,
        'new_total_cost': value.new_total_cost,
    };
}


